module.exports = __webpack_public_path__ + "img/festival-year-default.1776963e.png";